import { useEffect, useState } from 'react';
import Select from 'react-select';
import { getRequestOptions } from '../helpers/Fetchwrapper';

export interface SrCategoryOption {
	label: string;
	value: string;
}

export const ALL_SR_CATEGORIES: SrCategoryOption = { label: 'All', value: '' };

interface SrCategorySelectProps {
	/** The project whose SR categories are listed; nothing is loaded without one. */
	idProjects: string | number;
	value: SrCategoryOption;
	onChange: (option: SrCategoryOption) => void;
}

/**
 * SR category filter for the sales reports: "All", the project's SR categories and "Internal" (-1),
 * as the server lists them. A user who may see a single category gets it chosen, as in Daily Sales.
 */
export default function SrCategorySelect({ idProjects, value, onChange }: SrCategorySelectProps) {
	const [options, setOptions] = useState<SrCategoryOption[]>([ALL_SR_CATEGORIES]);

	useEffect(() => {
		if (!idProjects) {
			setOptions([ALL_SR_CATEGORIES]);
			return;
		}
		let active = true;
		fetch(process.env.REACT_APP_API_URL + 'allSrCategory?idProjects=' + idProjects, getRequestOptions())
			.then((resp) => resp.json())
			.then((data) => {
				if (!active || !Array.isArray(data)) {
					return;
				}
				const categories: SrCategoryOption[] = data.map((item: any) => ({
					label: item.sr_category_name,
					value: String(item.id_sr_categories),
				}));
				setOptions([ALL_SR_CATEGORIES, ...categories]);
				// A chosen category (e.g. from the link) gets its name, or falls back to All when the project lacks it.
				const current = categories.find((option) => option.value === value.value);
				if (categories.length === 1) {
					onChange(categories[0]);
				} else if (value.value !== '' && !current) {
					onChange(ALL_SR_CATEGORIES);
				} else if (current && current.label !== value.label) {
					onChange(current);
				}
			})
			.catch((error) => console.error('Error fetching SR categories:', error));
		return () => {
			active = false;
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [idProjects]);

	return (
		<Select
			value={options.find((option) => option.value === value.value) || value}
			onChange={(option: any) => onChange(option || ALL_SR_CATEGORIES)}
			options={options}
			menuPosition='fixed'
			styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
		/>
	);
}
